module.exports = __webpack_public_path__ + "static/media/minecraft.bc80c673.ttf";